// Biblioteca de 5 estrategias de trading profesionales, cada una con
// todos los campos requeridos por la página de detalle. Misma estructura
// para que futuras estrategias se añadan sin tocar el componente.

export const ESTRATEGIAS = [
  {
    id: "smc-order-block",
    nombre: "SMC — Entry en Order Block",
    tipo: "tendencia",
    mercados: ["BTC", "ETH", "Altcoins"],
    timeframes: ["1H", "4H", "D"],
    dificultad: "intermedia",
    winRate: "55-65%",
    ratioRR: "1:3 — 1:5",
    descripcion: "Entrada institucional en zonas de Order Block tras una rotura de estructura (BOS). Es la estrategia core de Smart Money Concepts. Se busca que el precio vuelva a testar la zona donde los institucionales colocaron sus órdenes, para entrar junto a ellos.",
    condicionesEntrada: [
      "1. Identificar la tendencia en timeframe superior (D o 4H).",
      "2. Esperar un Break of Structure (BOS) en la dirección de la tendencia.",
      "3. Identificar el Order Block que causó el BOS (última vela opuesta antes del impulso).",
      "4. Esperar que el precio regrese al rango del Order Block (retroceso).",
      "5. Confirmar con estructura en timeframe inferior (1H o 15m): CHoCH alcista en el OB.",
      "6. Entrar en la mitad superior del OB (zona de descuento dentro del OB).",
    ],
    stopLoss: "Por debajo del mínimo del Order Block (con pequeño margen del 0.5%).",
    takeProfit: "Siguiente zona de liquidez / máximo previo / extensión de Fibonacci 161.8%.",
    ejemploReal: "BTC en 4H muestra BOS alcista rompiendo 44.000. El OB alcista está entre 42.800-43.200 (última vela roja antes del impulso). Precio regresa a 43.000, en 1H se forma CHoCH alcista. Entrada en 43.100, SL en 42.700, TP en 45.500. R:R ≈ 1:3.",
    erroresComunes: [
      "Entrar en el OB sin esperar la confirmación en timeframe inferior.",
      "No identificar correctamente la tendencia del timeframe superior.",
      "Poner el SL demasiado ajustado dentro del OB — el precio puede barrerlo.",
      "Confundir el OB con una zona de consolidación aleatoria.",
    ],
    consejosPro: [
      "Los OB con FVG encima son más potentes — doble confluencia institucional.",
      "El OB más válido es el que causó el BOS más reciente.",
      "Mejor ignorar OBs que han sido testeados más de 2 veces.",
      "Combinar con liquidez: entra cuando el precio primero caza stops y luego regresa al OB.",
    ],
  },
  {
    id: "fvg-fill",
    nombre: "FVG Fill — Relleno de Ineficiencias",
    tipo: "reversion",
    mercados: ["BTC", "ETH", "Todos"],
    timeframes: ["15m", "1H", "4H"],
    dificultad: "basica",
    winRate: "60-70%",
    ratioRR: "1:2 — 1:3",
    descripcion: "El precio tiende a regresar a rellenar los Fair Value Gaps (FVG) creados por impulsos violentos. Esta estrategia aprovecha esta tendencia del mercado a buscar el equilibrio de precio. Simple y de alta probabilidad cuando se usa en confluencia con estructura.",
    condicionesEntrada: [
      "1. Identificar un impulso fuerte (alcista o bajista) con FVG visible.",
      "2. El FVG es el espacio entre la mecha alta de vela 1 y mecha baja de vela 3.",
      "3. Esperar que el precio retroceda hacia el FVG.",
      "4. Mejor si el FVG coincide con un Order Block o zona de soporte/resistencia.",
      "5. Entrar en el 50% del FVG (mitad del gap).",
      "6. Confirmar con vela de rechazo o estructura en TF inferior.",
    ],
    stopLoss: "Por debajo del FVG completo (si el precio lo cruza entero, el FVG ya no es válido).",
    takeProfit: "El extremo desde donde se formó el FVG — el impulso original.",
    ejemploReal: "ETH impulso alcista de 2.200 a 2.450. FVG entre 2.280-2.320. Precio retrocede a 2.300, vela doji de indecisión. Entrada en 2.300, SL en 2.270, TP en 2.420. R:R ≈ 1:4.",
    erroresComunes: [
      "Entrar en FVGs que ya fueron rellenados — un FVG lleno pierde su magnetismo.",
      "Ignorar la tendencia macro — operar FVGs contra tendencia tiene menos probabilidad.",
      "FVGs muy pequeños (<0.5%) tienen menos fiabilidad estadística.",
    ],
    consejosPro: [
      "Los FVGs en confluencia con Order Blocks son los más potentes.",
      "Un FVG rellenado a medias (50%) y rechazado es señal muy fuerte.",
      "En tendencia alcista, opera solo FVGs alcistas. No pelees contra la tendencia.",
      "Los FVGs en apertura de sesión (Londres, NY) tienen alta tasa de relleno.",
    ],
  },
  {
    id: "wyckoff-accumulation",
    nombre: "Wyckoff — Entrada en Acumulación",
    tipo: "reversion",
    mercados: ["BTC", "ETH"],
    timeframes: ["4H", "D", "W"],
    dificultad: "avanzada",
    winRate: "50-60%",
    ratioRR: "1:5 — 1:10",
    descripcion: "Richard Wyckoff desarrolló en los años 1930 un método para entender cómo los operadores institucionales acumulan y distribuyen posiciones. La fase de acumulación es el periodo donde los grandes compran silenciosamente antes de la gran subida. Identificarla correctamente ofrece los mejores R:R del mercado.",
    condicionesEntrada: [
      "1. Preliminary Support (PS): primer rebote tras caída fuerte — primer signo de interés comprador.",
      "2. Selling Climax (SC): vela bajista extrema con volumen muy alto — pánico vendedor.",
      "3. Automatic Rally (AR): rebote fuerte desde el SC — define el techo del rango.",
      "4. Secondary Test (ST): regresa al nivel del SC pero con menos volumen — confirmación.",
      "5. Creek (resistencia): el precio oscila en rango, forma máximos y mínimos.",
      "6. Jump Across the Creek (JAC): ruptura clara con volumen del techo del rango.",
      "7. Back Up to the Creek (BU): retesteo de la ruptura — última oportunidad de entrada.",
      "8. Entrada en el BU con SL bajo el rango de acumulación.",
    ],
    stopLoss: "Cierre de vela diaria por debajo del rango de acumulación (Selling Climax).",
    takeProfit: "Proyección de la altura del rango de acumulación × 2-3 desde la ruptura.",
    ejemploReal: "BTC en 2020: rango acumulación 6.000-12.000. SC en marzo 2020 (~4.000). AR a 10.000. Rango 6K-12K durante 6 meses. JAC en octubre 2020. BU a 12.000. Entrada 12.500, SL 9.000, TP objetivo 30.000+. R:R real: 1:10+.",
    erroresComunes: [
      "Identificar acumulaciones donde solo hay distribución — confundir fases.",
      "Entrar antes del JAC — el rango puede durar semanas o meses.",
      "No esperar el BU — entrar en el JAC con menos R:R.",
    ],
    consejosPro: [
      "El volumen es clave en Wyckoff — sin volumen no hay confirmación.",
      "Los rangos de acumulación más largos (3-6 meses) producen los mejores movimientos.",
      "BTC en gráfico semanal muestra Wyckoff clarísimo en 2019-2020 y 2022-2023.",
      "Combinar con on-chain: acumulación Wyckoff + Exchange Outflow = señal muy potente.",
    ],
  },
  {
    id: "breakout-retest",
    nombre: "Breakout + Retest de Resistencia",
    tipo: "ruptura",
    mercados: ["Todos"],
    timeframes: ["1H", "4H", "D"],
    dificultad: "basica",
    winRate: "55-65%",
    ratioRR: "1:2 — 1:4",
    descripcion: "Una de las estrategias más clásicas y efectivas. El precio rompe una resistencia clave con volumen, regresa a testear ese nivel (ahora soporte) y ofrece una entrada de bajo riesgo con la tendencia. El retest confirma que el viejo techo es el nuevo suelo.",
    condicionesEntrada: [
      "1. Identificar una resistencia bien definida (mínimo 2-3 toques previos).",
      "2. Esperar ruptura con vela de cierre CLARA por encima de la resistencia.",
      "3. Confirmar con volumen superior a la media en la vela de ruptura.",
      "4. Esperar el retest — el precio regresa a tocar la línea rota.",
      "5. En el retest, buscar vela de rechazo (doji, martillo, engulfing) en el nivel.",
      "6. Entrada al cierre de la vela de confirmación del retest.",
    ],
    stopLoss: "Por debajo del mínimo de la vela de confirmación del retest (o bajo la resistencia rota).",
    takeProfit: "Proyección de la altura del rango previo desde el nivel de ruptura.",
    ejemploReal: "BTC resistencia en 48.000 con 4 toques en 2 meses. Ruptura con vela diaria que cierra en 49.500 con volumen x2. Retest a 48.200, martillo de confirmación. Entrada 48.500, SL 47.200, TP 54.000. R:R ≈ 1:4.",
    erroresComunes: [
      "Entrar EN la ruptura sin esperar el retest — mucho riesgo de falsa ruptura.",
      "El retest no siempre llega al nivel exacto — dar margen del ±1-2%.",
      "Breakouts sin volumen tienen alta tasa de fallo.",
    ],
    consejosPro: [
      "El retest ideal toca el nivel con menor volumen que la ruptura.",
      "Si el retest baja mucho por debajo del nivel, el setup se invalida.",
      "Combinar con EMA200 o un Order Block como confluencia adicional.",
      "En cripto, los breakouts de máximos históricos (ATH) son especialmente potentes.",
    ],
  },
  {
    id: "london-breakout",
    nombre: "London Open Breakout",
    tipo: "ruptura",
    mercados: ["BTC", "ETH"],
    timeframes: ["15m", "1H"],
    dificultad: "basica",
    winRate: "55-60%",
    ratioRR: "1:2 — 1:3",
    descripcion: "La sesión de Londres (7:00-10:00 CET) es la más volátil del mercado cripto junto con la apertura de NY. Los institucionales europeos entran al mercado y crean movimientos directos. El precio suele romper el rango formado durante la noche asiática.",
    condicionesEntrada: [
      "1. Identificar el rango de la sesión asiática (00:00-07:00 CET): máximo y mínimo.",
      "2. Marcar esos niveles en el gráfico de 15 minutos.",
      "3. A partir de las 07:00 CET esperar la ruptura del rango asiático.",
      "4. Entrar al cierre de la primera vela de 15m que rompa claramente el rango.",
      "5. Alternativa: esperar micro-retest del rango roto en 5 minutos.",
    ],
    stopLoss: "En el extremo opuesto del rango asiático.",
    takeProfit: "Proyección de la altura del rango asiático desde el punto de ruptura.",
    ejemploReal: "BTC en rango 43.500-44.200 durante la noche. A las 7:15 CET vela de 15m cierra en 44.350. Entrada 44.350, SL 43.500, TP 44.900.",
    erroresComunes: [
      "Operar el London Breakout contra la tendencia del 4H.",
      "Días con eventos macroeconómicos importantes: no usar esta estrategia.",
      "Rango asiático muy estrecho (<0.5%) da mal R:R.",
    ],
    consejosPro: [
      "Funciona mejor cuando el rango asiático dura toda la noche sin fakeouts.",
      "Combinar con sesgo macro del día: si el mercado está en tendencia alcista, solo rupturas al alza.",
      "Los lunes y martes tienen los London Breakouts más limpios estadísticamente.",
    ],
  },
];

export const ESTRATEGIA_TIPOS = [
  { id: "todas", label: "Todas" },
  { id: "tendencia", label: "Tendencia" },
  { id: "reversion", label: "Reversión" },
  { id: "ruptura", label: "Ruptura" },
  { id: "rango", label: "Rango" },
  { id: "scalping", label: "Scalping" },
];

export const ESTRATEGIA_NIVELES = [
  { id: "todas", label: "Todas" },
  { id: "basica", label: "Básica" },
  { id: "intermedia", label: "Intermedia" },
  { id: "avanzada", label: "Avanzada" },
];

export const TIPO_COLORS = {
  tendencia: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  reversion: "border-cyan-400/40 bg-cyan-400/[0.08] text-cyan-200",
  ruptura: "border-orange-400/40 bg-orange-400/[0.08] text-orange-200",
  rango: "border-purple-400/40 bg-purple-400/[0.08] text-purple-200",
  scalping: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const NIVEL_COLORS = {
  basica: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  intermedia: "border-amber-400/40 bg-amber-400/[0.08] text-amber-200",
  avanzada: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const findEstrategia = (id) => ESTRATEGIAS.find((e) => e.id === id);
